import { Injectable } from '@angular/core';
import { SupabaseSelectQueryConfig } from '@examdojo/core/supabase';
import { ExamdojoSupabaseService, SupabaseBaseHttpService } from '@examdojo/supabase';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PayoutRequestListViewHttpModel } from './payout-request.model';

@Injectable({
  providedIn: 'root',
})
export class PayoutRequestHttpService extends SupabaseBaseHttpService<'payout_requests', 'billing'> {
  constructor(protected override readonly supabase: ExamdojoSupabaseService) {
    super(supabase);
  }

  readonly schema = 'billing';
  readonly tableName = 'payout_requests';

  fetchPaginatedListView(
    selectQueryConfig: SupabaseSelectQueryConfig = {},
  ): Observable<{ data: PayoutRequestListViewHttpModel[]; totalCount: number }> {
    const query = this.supabase.createSelectQuery('public', 'admin_payout_requests_view', selectQueryConfig);

    return from(query).pipe(
      map(({ data, count }) => ({
        data: data!,
        totalCount: count!,
      })),
    ) as Observable<{ data: PayoutRequestListViewHttpModel[]; totalCount: number }>;
  }

  fetchByUserId(userId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .eq('user_id', userId)
        .throwOnError()
        .then((response) => response.data!),
    );
  }
}
